import React from 'react'

import {
  classnames,
  Modal as TriangleModal,
  Button,
  Icon,
  Close,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  bool, node, string, func, oneOfType,
} from 'prop-types'

function Modal({
  isOpen = true,
  width = 'small',
  header = '',
  headerAddon = null,
  footer = null,
  customClass = '',
  ariaLabel = '',
  canClose = true,
  children = null,
  onClose: handleClose,
}) {
  return (
    <TriangleModal
      isOpen={isOpen}
      width={width}
      size={width}
      onClose={handleClose}
      canClose={canClose}
      aria-label={ariaLabel}
      customClass={classnames('app-modal', customClass)}
    >
      <div className="app-modal__header">
        {(header || headerAddon) && (
          <div className="app-modal__header-content">
            {typeof header === 'string' ? (
              <span className="app-modal__title cgt-heading-100">{header}</span>
            ) : (
              header
            )}
            {headerAddon && (
              <div className="app-modal__header-addon">{headerAddon}</div>
            )}
          </div>
        )}
        {canClose && (
          <div className="app-modal__close-button">
            <Button
              onClick={handleClose}
              size="tiny"
              type="ghost"
              variant="only-icon"
              expand
              icon={
                <Icon
                  svgComponent={Close}
                  size="small"
                  className="app-modal__close-icon"
                />
              }
            />
          </div>
        )}
      </div>

      <div className="app-modal__body">{children}</div>

      {footer && <div className="app-modal__footer">{footer}</div>}
    </TriangleModal>
  )
}

Modal.propTypes = {
  header: oneOfType([string, node]),
  onClose: func.isRequired,
  isOpen: bool,
  width: string,
  headerAddon: node,
  footer: node,
  customClass: string,
  ariaLabel: string,
  canClose: bool,
  children: node,
}

export default Modal
